import React from 'react'
import AboutTerm from './AboutTerm'
import Picture from './Picture'

function AboutText() {
  return <>
  <div className='row' data-aos="fade">
    <AboutTerm/>
    <Picture/>
    </div>
  </>
}

export default AboutText